export const LOCAL_STORAGE_TOKEN = "current-token";
export const LOCAL_STORAGE_LAYOUT_THEME = "layoutTheme";
export const LOCAL_STORAGE_LOCK_SCREEN = "screen";
export const LOGO = "hrefLogo";
export const ICON = "hrefIcon";
export const FAVICON = "hrefFavicon";
export const START_PAGE_PICTURE = "hrefStartPagePicture";

export const TIME_ZONE = "timeZone";

//LOGO
export const getLogo = () => {
  return localStorage.getItem(LOGO);
};

export const deleteLogo = () => {
  localStorage.removeItem(LOGO);
};

//ICON
export const getIcon = () => {
  return localStorage.getItem(ICON);
};

export const deleteIcon = () => {
  localStorage.removeItem(ICON);
};

//FAVICON

export const getFavicon = () => {
  return localStorage.getItem(FAVICON);
};

export const deleteFavicon = () => {
  localStorage.removeItem(FAVICON);
};

export const getStartPagePicture = () => {
  return localStorage.getItem(START_PAGE_PICTURE);
};
export const deleteStartPagePicture = () => {
  localStorage.removeItem(START_PAGE_PICTURE);
};

export const setLocalImageSrc = (file: File, name: string) => {
  const reader = new FileReader();
  reader.onloadend = () => {
    localStorage.setItem(name, reader.result as string);
  };
  reader.readAsDataURL(file);
};

// time zone

export const getTimeZone = (): number => {
  const timeZone = sessionStorage.getItem(TIME_ZONE);
  return timeZone ? +timeZone : 0;
};

export const setTimeZone = (value: number) => {
  return sessionStorage.setItem(TIME_ZONE, value.toString());
};
